import React, { useState, useRef, useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft, faTimes, faMapMarkerAlt, faPlus, faHome, faBriefcase, faEllipsisH,faInfoCircle } from '@fortawesome/free-solid-svg-icons';
import PlacesAutocomplete, { geocodeByAddress, getLatLng } from 'react-places-autocomplete';
import { useNavigate ,useLocation } from 'react-router-dom';
import Map from './images/Map.png';
import ArrowLeft from './images/ArrowLeft.png';
import Target from './images/Target1.png';
import GrayMap from './images/GrayMap.png';
import Buildingimage from './images/Buildingimage.png';

/* global google */  

function AddAddress() {
  const navigate = useNavigate();
  const location = useLocation();
  const from = location.state?.from ; 
  //console.log('Navigated from:', from);
  const quotationId = location.state?.StatePerameters?.quotationId || null;
  //console.log("📦 Quotation ID received:", location.state.StatePerameters);

  const [address, setAddress] = useState('');
  const [coordinates, setCoordinates] = useState({ lat: 0, lng: 0 });
  const [locations, setLocations] = useState([{ProjectName:'', BuilderName:''}]);
  const [isMapFullyLoaded, setIsMapFullyLoaded] = useState(false);
  const [showDetailsForm, setShowDetailsForm] = useState(false);
  const [selectedAddressType, setSelectedAddressType] = useState('Home');
  const [selectedAddressDetails, setSelectedAddressDetails] = useState('');
  const [searchText, setSearchText] = useState('');
  const [entryMethod, setEntryMethod] = useState('');
  // New state to control which screen to show
  const [showAddressSelection, setShowAddressSelection] = useState(true);
  const [editMode, setEditMode] = useState(false);
  const [editAddressData, setEditAddressData] = useState(null);
  const [formData, setFormData] = useState({
    project_name: '',
    area_sector_locality: '',
    landmark: ''
  });

  const [tempFormData, setTempFormData] = useState({
  project_name: '',
  area_sector_locality: '',
  landmark: ''
});

   useEffect(() => {
    if (location.state?.editMode && location.state?.addressData) {
      setEditMode(true);
      setEditAddressData(location?.state?.addressData);
      
      // Pre-populate form data
      const addressData = location?.state?.addressData;
      setFormData({
        project_name: addressData.project_name || '',
        area_sector_locality: addressData.area_sector_locality || '',
        landmark: addressData.landmark || ''
      });
      
      // Set address details
      setSelectedAddressDetails(addressData.area_sector_locality || '');
      setAddress(addressData.area_sector_locality || '');
      
      // Set address type
      setSelectedAddressType(addressData.address_type === 'project' ? 'Project' : 'Other');
      
      // Set coordinates if available
      if (addressData.latitude && addressData.longitude) {
        setCoordinates({
          lat: addressData.latitude,
          lng: addressData.longitude
        });
      }
      
      // Skip address selection and go directly to map/details
      setShowAddressSelection(false);
      setShowDetailsForm(true);
    }
  }, [location.state]);


  const handleEditModeDetailsForm = (addressData) => {
  setSelectedAddressType(addressData.address_type === 'project' ? 'Project' : 'Other');
  setFormData({
    project_name: addressData.project_name || '',
    area_sector_locality: addressData.area_sector_locality || '',
    landmark: addressData.landmark || ''
  });
  setTempFormData({
    project_name: addressData.project_name || '',
    area_sector_locality: addressData.area_sector_locality || '',
    landmark: addressData.landmark || ''
  });
  setSelectedAddressDetails(addressData.area_sector_locality || '');
  setShowDetailsForm(true);
};


  const fetchCurrentLocation = async () => {
    if (!navigator.geolocation) {
      console.error('Geolocation is not supported by your browser');
      return;
    }
    
    setIsMapFullyLoaded(false);
    
    try {
      const options = {
        enableHighAccuracy: true,
        timeout: 10000,
        maximumAge: 0
      };

      const position = await new Promise((resolve, reject) => {
        navigator.geolocation.getCurrentPosition(resolve, reject, options);
      });

      setCoordinates({
        lat: position.coords.latitude,
        lng: position.coords.longitude
      });

      const results = await geocodeByAddress(`${position.coords.latitude},${position.coords.longitude}`);
      const address = results[0].formatted_address;
      setAddress(address);
      setSelectedAddressDetails(address);
      
    } catch (error) {
      if (error.code === error.PERMISSION_DENIED) {
        console.error('User denied the request for Geolocation.');
      } else if (error.code === error.POSITION_UNAVAILABLE) {
        console.error('Location information is unavailable.');
      } else if (error.code === error.TIMEOUT) {
        console.error('The request to get user location timed out.');
      } else {
        console.error('An unknown error occurred:', error);
      }
    }
  };

  const clearAddress = () => {
    setAddress('');
    setCoordinates({ lat: 0, lng: 0 });
  };

  const handleSelect = async (address) => {
    setAddress(address);
    setSelectedAddressDetails(address);
    setIsMapFullyLoaded(false);

    if (document.activeElement) {
      document.activeElement.blur();
    }

    try {
      const results = await geocodeByAddress(address);
      const latLng = await getLatLng(results[0]);
      setCoordinates(latLng);
    } catch (error) {
      console.error('Error:', error);
    }
  };

  const handleChange = (address) => {
    setAddress(address);
    setSearchText(address);
    
    if (address.length > 0) {
      setIsMapFullyLoaded(false);
      
      setTimeout(() => {
        setIsMapFullyLoaded(true);
      }, 2000);
    }
  };

const handleSearchClick = () => {
  setEntryMethod('search');
  setAddress(''); 
  setSelectedAddressDetails(''); 
  setCoordinates({ lat: 16.5062, lng: 80.6480 }); // Vijayawada coordinates
  setShowAddressSelection(false);
};


  // Handle current location click
  const handleCurrentLocationClick = async () => {
  setEntryMethod('location');
  setShowAddressSelection(false);
  await fetchCurrentLocation();
};
  useEffect(() => {
    if(coordinates && coordinates.lat !== 0 && coordinates.lng !== 0) {
      renderMap();
    }
  }, [coordinates]);

  useEffect(() => {
    const handleResize = () => {
      setTimeout(() => {
        if (window.google && window.google.maps) {
          window.google.maps.event.trigger(window.google.maps, 'resize');
        }
      }, 100);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const renderMap = () => {
    if (!coordinates || !coordinates.lat || !coordinates.lng) {
      return;
    }
    
    const mapElement = document.getElementById('map');
    if (!mapElement) return;
    
    mapElement.innerHTML = '';
    
    const map = new window.google.maps.Map(mapElement, {
      center: { lat: coordinates.lat, lng: coordinates.lng },
      zoom: 15,
      disableDefaultUI: true,
      zoomControl: true,
      mapTypeControl: false,
      streetViewControl: false,
      fullscreenControl: false
    });

    google.maps.event.addListenerOnce(map, 'tilesloaded', () => {
      setIsMapFullyLoaded(true);
    });

    map.addListener('click', async (event) => {
      const clickedLat = event.latLng.lat();
      const clickedLng = event.latLng.lng();
      
      setCoordinates({
        lat: clickedLat,
        lng: clickedLng
      });

      try {
        const results = await geocodeByAddress(`${clickedLat},${clickedLng}`);
        const clickedAddress = results[0].formatted_address;
        setAddress(clickedAddress);
        setSelectedAddressDetails(clickedAddress);
      } catch (error) {
        console.error('Error getting address:', error);
      }
    });

    if (coordinates.lat && coordinates.lng) {
      const customMarker = new window.google.maps.Marker({
        position: { lat: coordinates.lat, lng: coordinates.lng },
        map: map,
        title: 'Selected Location',
        icon: {
          path: 'M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z',
          fillColor: '#DC2626',
          fillOpacity: 1,
          strokeColor: '#FFFFFF',
          strokeWeight: 2,
          scale: 1.5,
          anchor: new window.google.maps.Point(12, 24)
        }
      });
    }
  };

 const handleAddMoreDetails = () => {
  setSelectedAddressType(tempFormData.project_name ? 'Project' : 'Project');
  
  // Restore previous form data if it exists
  setFormData({
    project_name: tempFormData.project_name || '',
    area_sector_locality: tempFormData.area_sector_locality || '',
    landmark: tempFormData.landmark || ''
  });
  
  setShowDetailsForm(true);
};

  const closeDetailsForm = () => {
    setShowDetailsForm(false);
  };

  const handleAddressTypeSelect = (type) => {
    setSelectedAddressType(type);
  };

 const saveAddress = async () => {
  try {
    const userData = JSON.parse(sessionStorage.getItem("userData"));
    const customerId = userData?._id;
    const token = userData?.token;

    if (!customerId || !token) {
      alert("User information not found. Please login again.");
      return;
    }

    if (
      selectedAddressType === "Project" &&
      (!formData.project_name || formData.project_name.trim() === "")
    ) {
      alert("Please enter project name");
      return;
    }

    let addressData = {
      customer_id: customerId,
      area_sector_locality: selectedAddressDetails || address,
      latitude: coordinates.lat,
      longitude: coordinates.lng,
      is_default: true,
      is_active: true,
    };

    if (selectedAddressType === "Project") {
      addressData = {
        ...addressData,
        address_type: "project",
        project_name: formData.project_name.trim(),
        landmark: formData.landmark.trim(),
      };
    } else {
      addressData = {
        ...addressData,
        address_type: "other",
        landmark: formData.landmark.trim(),
      };
    }

    console.log("Saving address:", addressData);

    let response;
    let apiUrl;

    if (editMode && editAddressData) {
      // Update existing address
      apiUrl = `${process.env.REACT_APP_FORE_BRICKBUCKET}customer/delivery-address/updateDeliveryAddress?address_id=${editAddressData._id}`;
      response = await fetch(apiUrl, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          "x-token": token,
        },
        body: JSON.stringify(addressData),
      });
    } else {
      // Create new address
      apiUrl = `${process.env.REACT_APP_FORE_BRICKBUCKET}customer/delivery-address/createDeliveryAddress`;
      response = await fetch(apiUrl, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "x-token": token,
        },
        body: JSON.stringify(addressData),
      });
    }

    const result = await response.json();
    console.log("API Response address:", result);

    if (result.success) {
      setShowDetailsForm(false);

      // ✅ Check from where this page was opened
     const from = location.state?.from || "/consumer/home";   // keep paths consistent
const quotationId = location.state?.StatePerameters?.quotationId || null;
/* console.log('location', location)
console.log(from,quotationId ) */

if (quotationId && from === "/consumer/app/orderdetails") {
  console.log('enterd to updateOrderWithDeliveryAddressId ')
  await updateOrderWithDeliveryAddressId(quotationId, result.data._id);
}

       navigate(`${from}`,{
           state: location?.state?.StatePerameters || {}
        })
    } else {
      alert(
        result.message ||
          `Failed to ${editMode ? "update" : "save"} address`
      );
    }
  } catch (error) {
    console.error(
      `Error ${editMode ? "updating" : "saving"} address:`,
      error
    );
    alert(
      `An error occurred while ${
        editMode ? "updating" : "saving"
      } the address`
    );
  }
};

const updateOrderWithDeliveryAddressId = async (quotationId, deliveryAddressId) => {
  try {
    if (!quotationId || !deliveryAddressId) {
      console.error("Missing quotationId or deliveryAddressId");
      return;
    }

    const url = process.env.REACT_APP_FORE_BRICKBUCKET;

    const response = await fetch(`${url}customer/quotations/update-order-with-delivery-address-id`, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ quotationId , deliveryAddressId }),
    });
  // console.log('response', response)
    if (!response.ok) {
      throw new Error(`Failed to update order: ${response.status}`);
    }

    const data = await response.json();
    return data;

  } catch (error) {
    console.error("Error updating order:", error);
    throw error;
  }
};



  // Choose Delivery Address Screen
  if (showAddressSelection) {
    return (
      <div className='flex flex-col w-full min-h-screen bg-white'>
        {/* Header */}
        <div className="flex items-center px-2 py-2 mt-2">
          <button onClick={() => navigate(-1)} className="mr-3">
<img
  src={ArrowLeft}
  className="w-10 h-6 text-gray-600 cursor-pointer flex-shrink-0"
  onClick={() => {
    setShowAddressSelection(true); // Go back to address selection
    setAddress(''); // Clear address
    setSelectedAddressDetails(''); // Clear details
    setCoordinates({ lat: 0, lng: 0 }); // Clear coordinates
  }}
/>
          </button>
          <h1 className="text-md font-medium text-[#00000]">Choose Delivery Address</h1>
        </div>
        
        {/* Main content with white background */}
        <div className="flex-1 bg-white p-4">
          {/* Search bar */}
          <div className="relative">
            <div className="absolute inset-y-0 left-0 flex items-center pl-3">
              <svg className="h-5 w-5 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
              </svg>
            </div>
            <input
              type="text"
              placeholder="Search area, apartment or pincode"
              value={searchText}
              onChange={(e) => setSearchText(e.target.value)}
              onClick={handleSearchClick}
              className="w-full pl-10 pr-4 py-3 bg-gray-100 rounded-lg focus:outline-none focus:border-red-500 focus:ring-1 focus:ring-red-500 placeholder-gray-500"
            />
          </div>

          {/* Current Location Section */}
          <div className="mt-4 border border-gray-300 rounded-lg p-2">
            <div className="flex items-center justify-between">
              {/* Left side - Image and text */}
              <div className="flex items-center flex-1" onClick={handleCurrentLocationClick}>
                <div className="flex items-center justify-start">
                  <img src={Target} className="h-8 w-14" />
                </div>
                <div className="ml-1">
                  <h3 className="text-md font-semibold text-[#F84C5C]">Use current location</h3>
                  <p className="text-sm text-gray-500">Enable your current location for better services</p>
                </div>
              </div>

              {/* Right side - Enable button */}
              <button 
                onClick={handleCurrentLocationClick}
                className="px-4 py-1 border border-red-500 text-red-500 rounded-md text-sm font-medium hover:bg-red-50"
              >
                Enable
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }

  // Map Screen (existing functionality)
  return (
    <div className="flex flex-col w-full h-screen relative">
      {/* Header with Arrow and Search Bar on same line */}
      <div className="w-full px-2 py-4 sticky top-0 z-20  bg-gray-100">
        <div className="flex items-center space-x-2">
          {/* Arrow Left */}
          <img
            src={ArrowLeft}
            className="w-10 h-6 text-gray-600 cursor-pointer flex-shrink-0"
            onClick={() => {
              setShowAddressSelection(true); // Go back to address selection
              setAddress(''); // Clear address
              setSelectedAddressDetails(''); // Clear details
              setCoordinates({ lat: 0, lng: 0 });
               setSearchText(''); // Clear coordinates
            }}
          />
          
          {/* Search bar */}
          <div className="flex-1 pr-2">
            <PlacesAutocomplete value={address} onChange={handleChange} onSelect={handleSelect}>
              {({ getInputProps, suggestions, getSuggestionItemProps, loading }) => (
                <div>
                  <div className="relative">
                    <div className="absolute inset-y-0 left-0 flex items-center pl-3">
                      <svg className="h-5 w-5 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
                                          </svg>
                    </div>
                    <input
                      {...getInputProps({
                        placeholder: 'Search area, apartment or pincode',
                        className: 'w-full py-3 pl-10 pr-12 text-gray-500 text-xs bg-white focus:outline-none rounded-lg focus:border-red-500 focus:ring-1 focus:ring-red-500 placeholder-gray-500'
                      })}
                    />
                    {/* Clear button */}
                    {address && (
                      <div 
                        className="absolute inset-y-0 right-3 flex items-center cursor-pointer"
                        onClick={clearAddress}
                      >
                        <div className="w-6 h-6 bg-gray-500/80 rounded-full flex items-center justify-center hover:bg-gray-600/80 transition-colors">
                          <FontAwesomeIcon 
                            icon={faTimes} 
                            className="w-3 h-3 text-white"
                          />
                        </div>
                      </div>
                    )}
                  </div>
                  {/* Autocomplete suggestions */}
                  {(loading || suggestions.length > 0) && (
                    <div className="bg-white rounded-lg shadow-lg absolute z-50 w-full mt-2 overflow-hidden border border-gray-200">
                      {loading && (
                        <div className="p-4 text-gray-600 flex items-center">
                          <div className="w-4 h-4 border-2 border-red-500 border-t-transparent rounded-full animate-spin mr-3"></div>
                          Searching...
                        </div>
                      )}
                      {suggestions.map(suggestion => {
                        const className = suggestion.active
                          ? 'p-4 bg-red-500 text-white cursor-pointer'
                          : 'p-4 hover:bg-gray-50 cursor-pointer border-b border-gray-100 last:border-b-0';
                        return (
                          <div
                            {...getSuggestionItemProps(suggestion, {
                              className
                            })}
                            key={suggestion.placeId}
                          >
                            <div className="flex items-center">
                              <FontAwesomeIcon
                                icon={faMapMarkerAlt}
                                className={`w-4 h-4 mr-3 ${suggestion.active ? 'text-white' : 'text-gray-400'}`}
                              />
                              <span className="text-sm">{suggestion.description}</span>
                            </div>
                          </div>
                        );
                      })}
                    </div>
                  )}
                </div>
              )}
            </PlacesAutocomplete>
          </div>
        </div>
      </div>

      {/* Spacing below search bar */}
      <div className="mb-1"></div>

      {/* Map display - Reduced height */}
     <div className="flex-1 relative mb-0" style={{ maxHeight: 'calc(100vh - 200px)' }}>
        {(coordinates.lat !== 0 && coordinates.lng !== 0) ? (
          <div
            id="map"
            className="w-full h-full"
           
          />
        ) : (
          <div className="w-full h-full flex items-center justify-center bg-gray-50">
            <div className="text-center">
              <p className="text-gray-400 text-sm">Search for a location to view map</p>
            </div>
          </div>
        )}

        {/* Loading overlay for map */}
        {!isMapFullyLoaded && coordinates.lat !== 0 && coordinates.lng !== 0 && (
          <div className="absolute inset-0 flex items-center justify-center bg-white/90 backdrop-blur-sm z-10 rounded">
            <div className="flex flex-col items-center">
              <div className="w-10 h-10 border-3 border-red-500 border-t-transparent rounded-full animate-spin mb-3"></div>
              <span className="text-gray-600 text-base font-medium">Loading map...</span>
            </div>
          </div>
        )}
      </div>


      {/* Selected Address Display - Bottom overlay */}
            {/* Selected Address Display - Bottom overlay - ALWAYS VISIBLE */}
      {address && (
        <div className="bg-white shadow-md border-t border-gray-200 fixed bottom-0 left-0 right-0 z-20 max-h-[40vh] overflow-y-auto">
          <div className="p-4 pb-6">
            {/* Location details */}
            <div className="flex items-start space-x-1 mb-4">
              <div className="mt-1">
                <img
                  src={GrayMap}
                  className="w-4 h-4 text-red-500"
                />
              </div>
              <div className="flex-1">
                <p className="text-gray-700 text-sm leading-relaxed">{address}</p>
              </div>
            </div>
            
            {/* Add more details button */}
            <button
              onClick={handleAddMoreDetails}
              className="w-full bg-[#F43042] hover:bg-red-700 text-white text-sm font-semibold py-2 px-4 rounded-lg flex items-center justify-center space-x-2 "
            >
              <span>Use this Location</span>
            </button>
          </div>
          
          {/* Safe area for mobile devices */}
          <div className="h-2 bg-white"></div>
        </div>
      )}


      {/* Enhanced Details Form Popup */}
{showDetailsForm && (
  <div className="fixed inset-0 bg-black/60 backdrop-blur-sm z-50 flex items-end justify-center">
    <div className="bg-white rounded-t-3xl w-full max-w-md max-h-[85vh] flex flex-col transition-all duration-300 ease-in-out transform translate-y-0" 
         id="address-popup">
      {/* Header */}
      <div className="flex items-center justify-between p-4 border-b border-gray-200 flex-shrink-0">
        <h2 className="text-md font-bold text-gray-900">
          {editMode ? 'Edit Address Details' : 'Add Address Details'}
        </h2>
        <button
          onClick={() => {
            closeDetailsForm();
            if (editMode) {
              navigate('/consumer/cartpreview', {
                state: { showLocationPopup: true }
              });
            }
          }}
          className="w-6 h-6 bg-gray-100 hover:bg-gray-200 rounded-full flex items-center justify-center transition-colors"
        >
          <FontAwesomeIcon icon={faTimes} className="w-3 h-3 text-gray-600" />
        </button>
      </div>
      
      {/* Content */}
      <div className="flex-1 overflow-y-auto p-4 space-y-3">
        {/* Info Box */}
        <div className="bg-red-50 text-[#F30F0F] rounded-md p-2 flex items-start space-x-2">
          <FontAwesomeIcon icon={faInfoCircle} className="w-3 h-3 mt-1 text-red-500" />
          <p className="text-[10px] font-medium">
            {editMode ? 'Please update address details for a hassle-free delivery experience.' : 'Please check address details for a hassle-free delivery experience.'}
          </p>
        </div>
        
        {/* Address Type */}
        <div>
          <p className="text-xs font-medium text-[#A8A1A1] mb-2">
            {editMode ? 'Update address as *' : 'Save address as *'}
          </p>
          <div className="flex gap-2">
            <button
              onClick={() => handleAddressTypeSelect('Project')}
              className={`border py-1.5 px-2 rounded-lg text-sm transition-all w-20 flex items-center justify-center ${
                selectedAddressType === 'Project' ? 'border-red-500 text-red-600' : 'border-[#E0D9D9] text-[#170101]'
              }`}
            >
              <img src={Buildingimage} alt="Building" className="w-7 h-4" />
              <span className="text-xs">Project</span>
            </button>
            <button
              onClick={() => handleAddressTypeSelect('Other')}
              className={`border py-1 px-3 rounded-lg text-sm transition-all w-20 ${
                selectedAddressType === 'Other' ? 'border-red-500 text-red-600' : 'border-[#E0D9D9] text-[#170101]'
              }`}
            >
             ... Other
            </button>
          </div>
        </div>

        {/* Project Name */}
        {selectedAddressType === 'Project' && (
          <div>
            <label className="block text-xs font-medium text-[#A8A1A1] mb-1">Project Name *</label>
            <input
              type="text"
              value={formData.project_name}
              onChange={(e) => setFormData({...formData, project_name: e.target.value})}
              className="w-full px-3 py-2 border border-gray-200 rounded-lg focus:outline-none focus:ring-red-200 focus:border-red-500 text-gray-800 font-medium text-xs"
              placeholder={editMode ? "Update project name" : "Enter project name"}
              onFocus={() => {
                const popup = document.getElementById('address-popup');
                if (popup) {
                  popup.style.position = 'fixed';
                  popup.style.top = '10vh';
                  popup.style.bottom = 'auto';
                  popup.style.transform = 'translateY(0)';
                }
              }}
              onBlur={() => {
                setTimeout(() => {
                  const popup = document.getElementById('address-popup');
                  if (popup && !document.activeElement.matches('input')) {
                    popup.style.position = 'relative';
                    popup.style.top = 'auto';
                    popup.style.bottom = 'auto';
                    popup.style.transform = 'translateY(0)';
                  }
                }, 100);
              }}
            />
          </div>
        )}
        
        {/* Address */}
        <div>
          <label className="block text-xs font-medium text-[#A8A1A1] mb-1">Area / Sector / Locality *</label>
          <div className="relative">
            <input
              type="text"
              value={selectedAddressDetails}
              onChange={(e) => setSelectedAddressDetails(e.target.value)}
              className="w-full px-3 py-2 pr-16 border border-gray-200 rounded-lg focus:outline-none focus:ring-red-200 focus:border-red-500 text-[#00000] font-medium text-xs"
              placeholder={editMode ? "Update area, sector, or locality" : "Enter area, sector, or locality"}
              onFocus={() => {
                const popup = document.getElementById('address-popup');
                if (popup) {
                  popup.style.position = 'fixed';
                  popup.style.top = '10vh';
                  popup.style.bottom = 'auto';
                  popup.style.transform = 'translateY(0)';
                }
              }}
              onBlur={() => {
                setTimeout(() => {
                  const popup = document.getElementById('address-popup');
                  if (popup && !document.activeElement.matches('input')) {
                    popup.style.position = 'relative';
                    popup.style.top = 'auto';
                    popup.style.bottom = 'auto';
                    popup.style.transform = 'translateY(0)';
                  }
                }, 100);
              }}
            />
      <button
  onClick={() => {
    // Store current form data before closing
    setTempFormData({
      project_name: formData.project_name,
      area_sector_locality: selectedAddressDetails,
      landmark: formData.landmark
    });
    setShowDetailsForm(false);
    if (editMode) {
      // In edit mode, keep the current address displayed on map screen
      setShowAddressSelection(false);
      // DON'T clear the address - keep it displayed
      // setAddress(''); // Remove this line
      // setSelectedAddressDetails(''); // Remove this line
      // setCoordinates({ lat: 0, lng: 0 }); // Remove this line
      
      // Keep existing address and coordinates so map shows current selection
      // User can then search for new address or click map to change
      setSearchText(''); // Only clear search text
    }
  }}
  className="absolute right-2 top-1/2 transform -translate-y-1/2 text-xs font-medium text-red-500 hover:text-red-600 transition-colors bg-white px-1"
>
  Change
</button>





          </div>
        </div>

        {/* Landmark */}
        <div>
          <label className="block text-xs font-medium text-[#A8A1A1] mb-1">Nearby Landmark (Optional)</label>
          <input
            type="text"
            value={formData.landmark}
            onChange={(e) => setFormData({...formData, landmark: e.target.value})}
            className="w-full px-3 py-2 border border-gray-200 rounded-lg focus:outline-none focus:ring-red-200 focus:border-red-500 text-[#00000] font-medium text-xs"
            placeholder={editMode ? "Update landmark" : "Enter landmark"}
            onFocus={() => {
              const popup = document.getElementById('address-popup');
              if (popup) {
                popup.style.position = 'fixed';
                popup.style.top = '10vh';
                popup.style.bottom = 'auto';
                popup.style.transform = 'translateY(0)';
              }
            }}
            onBlur={() => {
              setTimeout(() => {
                const popup = document.getElementById('address-popup');
                if (popup && !document.activeElement.matches('input')) {
                  popup.style.position = 'relative';
                  popup.style.top = 'auto';
                  popup.style.bottom = 'auto';
                  popup.style.transform = 'translateY(0)';
                }
              }, 100);
            }}
          />
        </div>
      </div>
      
      {/* Footer */}
      <div className="p-4 bg-white border-t border-gray-100 flex-shrink-0">
        <button
          onClick={saveAddress}
          className="w-full bg-[#D93025] text-white font-bold py-3 px-4 rounded-xl"
        >
          <span className="text-sm">{editMode ? 'Update Address' : 'Save Address'}</span>
        </button>
      </div>
    </div>
  </div>
)}






    </div>
  );
}

export default AddAddress;
